import React, { useState, useEffect } from 'react';
import { useSettings, useStore } from '../context/store';

import FilterMultiselect from './filters/FilterMultiselect';
import FilterRange from './filters/FilterRange';
import FilterPills from './filters/FilterPills';
import FilterTrueFalse from './filters/FilterTrueFalse';

export default function Filters() {
    const { 
        state,
        dispatch 
    } = useStore();

    if (typeof NodeList.prototype.forEach === "undefined") {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    const settings = useSettings();

    const getNicename = ( key, value ) => {
        if ( 'undefined' !== typeof settings.filterNicenames[ key ] && 'undefined' !== typeof settings.filterNicenames[ key ][ value ] ) {
            return settings.filterNicenames[ key ][ value ];
        }

        return value;
    }

    const toggleParentActiveClass = ( e, reset = true ) => {
        const isActive = e.currentTarget.parentNode.classList.contains('active')
        
        if ( reset ) {
            document.querySelectorAll('.ygl-filter').forEach( elem => {
                elem.classList.remove('active');
            })

            if ( ! isActive ) {
                e.currentTarget.parentNode.classList.add('active')
            }
        } else {
            e.currentTarget.parentNode.classList.toggle('active')
        }
    }

    if ( 'undefined' !== typeof settings && settings.filters.length && 'undefined' !== typeof state ) {

        let heroClass = 'ygl-hero';
        if ( state.mobileFiltersOpen ) {
            heroClass += ' ygl-hero--filters-open';
        }

        return (
			<div className="container"> 
				<div className={ heroClass }> 
					<button className="ygl-app__mobile-btn" onClick={ () => dispatch({ type: 'toggleMobileFiltersOpen' }) }><span>Filter</span></button> 

                    <div className="ygl-filters">
                        <div className="ygl-filters__holder">
                            {settings.filters.map( (filter, index) => {
                                switch ( filter.type ) {
                                    case 'multiselect':
                                        return <FilterMultiselect toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                    case 'range':
                                        return <FilterRange toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                    case 'pills':
                                        return <FilterPills toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                    case 'true_false':
                                        return <FilterTrueFalse toggleParentActiveClass={ toggleParentActiveClass } filter={ filter } key={ index } />
                                    default:
                                        console.warn( `No filter mapping for type: ${filter.type}` );
                                }
                            })}
                        </div>
                        <div className="ygl-active-filters">
                            <div className="ygl-active-filters_inner">
                                {Object.keys( state.filters ).map((key) => {
                                    const value = state.filters[ key ];

                                    if ( 'city_neighborhood' === key ) {
                                        return (
                                            value.split(',').map((city, index) => {
                                                if ( 
                                                    ! city.includes(':') || 
                                                    ! value.includes( `${city.split(':')[0]},` ) ||
                                                    value === city
                                                ) {
                                                    return (
                                                        <button 
                                                            className="ygl-active-filters__option" 
                                                            onClick={() => dispatch({ 
                                                                type: 'removeFilterFromList', 
                                                                payload: { 
                                                                    field: key, 
                                                                    value: city 
                                                                } 
                                                            })}
                                                            key={ `${key}-${index}`}
                                                        >
                                                            {city}
                                                        </button>
                                                    )
                                                }
                                            })
                                        )
                                    } else {
                                        return (
                                            <button 
                                                className="ygl-active-filters__option" 
                                                onClick={ () => dispatch({ type: 'removeFilter', payload: key })}
                                                key={ key }
                                            >
                                                {getNicename( key, value )}
                                            </button>
                                        )
                                    }
                                })}
                            </div>
                            <button className="ygl-active-filters__search-button" onClick={ () => dispatch({ type: 'toggleMobileFiltersOpen' }) }>Search Rentals</button>
                            <button className="ygl-clear-filters" onClick={ e => dispatch({ type: 'clearFilters' }) }>Clear Filters</button>
                        </div>
                    </div>
			    </div>
			</div>
        )
    }

    return '';
}